<template>
  <router-link :to="route" class="sell-and-rent-row">
    <div class="cell">
      <h5>{{ user.name }}</h5>
    </div>
    <div class="cell">
      <p>{{ user.phone_number }}</p>
    </div>
    <div class="cell">
      <h5>{{ home.address_number }}</h5>
    </div>
    <div class="cell">
      <p>{{ home.project.name }}</p>
    </div>
    <div class="cell">
      <p>{{ home.plot_code }}</p>
    </div>
    <div class="cell currency">
      <p>{{ home.usable_area }}</p>
    </div>
    <div class="cell currency">
      <p>{{ home.sell_price | commas("-") }}</p>
    </div>
    <div class="cell currency">
      <p>{{ home.rent_price | commas("-") }}</p>
    </div>
    <div class="cell">
      <h5>{{ created_at | date }}</h5>
    </div>
    <div class="cell">
      <h5>{{ updated_by.first_name }}</h5>
    </div>
    <div class="cell">
      <h5 class="current-status" :class="css">{{ status }}</h5>
    </div>
  </router-link>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  props: ["user", "home", "created_at", "status", "updated_by", "route"],
  data() {
    return {};
  },
  computed: {
    css() {
      return { completed: this.isCompleted };
    }
  }
});
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.sell-and-rent-row {
  display: grid;
  grid-template-columns: repeat(10, 1fr) 150px;
  grid-gap: 15px;
  align-items: center;

  padding: ($space / 3) $space;

  &:hover {
    background: #fafafa;
    cursor: pointer;
    text-decoration: none;
  }
}

.sell-and-rent-row > .cell {
  > h5 {
    font-size: 16px;
  }

  > p {
    font-size: 14px;
  }

  > h5,
  > p {
    line-height: 1.6;
    margin: 0;
  }

  &.currency > p {
    margin-right: 30px;
    text-align: right;
  }
}

.current-status {
  &.completed {
    color: $success-color;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/sell-and-rent/components/SellAndRentRow.vue